import { TextEdit } from '@powerportalspro/react-fluent';

export function TextEditMainSample() {
  return <TextEdit columnName="ppp_mobilephone" />;
}
